'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'tv-retro';
var width = 512;
var height = 512;
var aliases = [128250];
var unicode = 'f401';
var svgPathData = ['M48 144l0 288 416 0 0-288-416 0zm48 48l256 0 0 192-256 0 0-192zm336 40a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm0 80a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z', 'M169 7L152-9.9 118.1 24c5 5 29 29 72 72L0 96 0 480 512 480 512 96 321.9 96c43-43 67-67 72-72L360-9.9c-.8 .8-33.1 33.1-97 97l-7 7-7-7-80-80zM48 432l0-288 416 0 0 288-416 0zM96 192l0 192 256 0 0-192-256 0zm312 64a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTvRetro = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;